import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { PaymentMethod } from '@/enums';
import { PaymentMethodIcon } from './payment-method-icon';
import { PaymentMethodOption } from '@/contexts/payments-context';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  onChangePaymentMethod: () => void;
  paymentMethod: PaymentMethod;
  selectedPaymentMethod: PaymentMethodOption | null;
}

export const PaymentMethodBanner: React.FC<Props> = ({
  onChangePaymentMethod,
  paymentMethod,
  selectedPaymentMethod,
}) => {
  const [styles] = useStyles();

  return (
    <View style={[styles.paymentMethodRow]}>
      <View style={[styles.paymentMethod]}>
        <PaymentMethodIcon
          style={styles.paymentMethodIcon}
          type={paymentMethod}
        />
        <Text style={styles.paymentMethodLabel}>
          {selectedPaymentMethod?.displayText}
        </Text>
      </View>
      <Button
        onPress={onChangePaymentMethod}
        size="small"
        style={styles.changeButton}
        textStyle={styles.changeButtonText}
        trackingData={{ name: 'autopay.change_payment_method_button' }}
        type="tertiary"
      >
        {i18n.t('change')}
      </Button>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  changeButton: {
    paddingHorizontal: 0,
  },
  changeButtonText: {
    ...TYPOGRAPHY.small,
    fontWeight: '700',
    lineHeight: 14,
  },
  paymentMethod: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
  },
  paymentMethodIcon: {
    height: 24,
    width: 24,
  },
  paymentMethodLabel: {
    ...TYPOGRAPHY.medium,
    fontWeight: '600',
  },
  paymentMethodRow: {
    alignItems: 'center',
    borderColor: theme.colors.stroke,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
}));
